// {
//   "name": "iconic-lookbook-second.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-lookbook-second')) {
    return;
  }

  class IconicLookbookSecond extends HTMLElement {
    constructor() {
      super();

      this.showLookPanel = this.showLookPanel.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleModalClick = this.handleModalClick.bind(this);
      this.handleSwipeStart = this.handleSwipeStart.bind(this);
      this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
      this.handleDragStart = this.handleDragStart.bind(this);
      this.handleDragMove = this.handleDragMove.bind(this);
      this.handleDragEnd = this.handleDragEnd.bind(this);

      this.isSwiping = false;
      this.startX = 0;
      this.startY = 0;
      this.isDown = false;
      this.dragStartX = 0;
      this.scrollLeft = 0;
      this.activeDragPanel = null;
    }

    connectedCallback() {
      let nextElem = this.nextElementSibling;
      while (nextElem && !nextElem.classList.contains('iconic-lookbook-modal')) {
        nextElem = nextElem.nextElementSibling;
      }
      this.modal = nextElem;

      if (this.modal) {
        this.modal.addEventListener('click', this.handleModalClick);

        this.modal.addEventListener('touchstart', this.handleSwipeStart, { passive: true });
        this.modal.addEventListener('touchend', this.handleSwipeEnd, { passive: true });
        this.modal.addEventListener('mousedown', this.handleSwipeStart);
        this.modal.addEventListener('mouseup', this.handleSwipeEnd);

        this.modal.addEventListener('mousedown', this.handleDragStart);
        this.modal.addEventListener('mousemove', this.handleDragMove);
        this.modal.addEventListener('mouseup', this.handleDragEnd);
        this.modal.addEventListener('mouseleave', this.handleDragEnd);
      }

      this.addEventListener('click', this.handleTriggerClick);
    }

    showLookPanel(index, direction) {
      if (!this.modal) return;
      
      const allPanels = this.modal.querySelectorAll('.iconic-look-panel');
      const total = parseInt(this.modal.getAttribute('data-total-looks') || allPanels.length, 10);
      const loop = this.modal.getAttribute('data-loop') !== 'false';
      const curIndex = parseInt(this.modal.getAttribute('data-current-index') || '-1', 10);

      if (!loop) {
        if (index < 0) index = 0;
        if (index >= total) index = total - 1;
      } else {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
      }

      if (direction && index === curIndex) return;

      allPanels.forEach((p) => {
        p.classList.remove('is-visible', 'products-open');
        p.style.display = 'none';
        const img = p.querySelector('.iconic-look-panel__image');
        if (img) img.classList.remove('slide-in-left', 'slide-in-right');
      });
      this.modal.style.setProperty('--popup-height', '0px');

      const targetPanel = this.modal.querySelector(`.iconic-look-panel[data-look-index="${index}"]`);
      if (!targetPanel) return;

      targetPanel.style.display = 'flex';
      targetPanel.classList.add('is-visible');

      if (direction) {
        const imageEl = targetPanel.querySelector('.iconic-look-panel__image');
        if (imageEl) {
          const animClass = direction === 'next' ? 'slide-in-right' : 'slide-in-left';
          imageEl.classList.add(animClass);
          imageEl.addEventListener('animationend', () => {
            imageEl.classList.remove(animClass);
          }, { once: true });
        }
      }

      this.modal.setAttribute('data-current-index', index);

      const counter = this.modal.querySelector('.iconic-modal__counter');
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + total;
      }

      if (window.innerWidth < 768) {
        const delay = direction ? 400 : 50;
        setTimeout(() => {
          targetPanel.classList.add('products-open');
          const productsEl = targetPanel.querySelector('.iconic-look-panel__products');
          if (productsEl) {
             this.modal.style.setProperty('--popup-height', productsEl.offsetHeight + 'px');
          }
        }, delay);
      }
    }

    handleTriggerClick(e) {
      const trigger = e.target.closest('.iconic-look-trigger');
      if (trigger) {
        e.preventDefault();
        const slideIndex = parseInt(trigger.getAttribute('data-slide-index') || '0', 10);
        this.showLookPanel(slideIndex);
        if (this.modal) {
          this.modal.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      }
    }

    handleModalClick(e) {
      const addToCartBtn = e.target.closest('.iconic-add-to-cart-btn');
      if (addToCartBtn) {
        e.preventDefault();
        this.addLooksToCart(addToCartBtn);
        return;
      }

      const prevBtn = e.target.closest('.iconic-modal__nav--prev');
      if (prevBtn) {
        e.preventDefault();
        const cur = parseInt(this.modal.getAttribute('data-current-index') || '0', 10);
        this.showLookPanel(cur - 1, 'prev');
        return;
      }

      const nextBtn = e.target.closest('.iconic-modal__nav--next');
      if (nextBtn) {
        e.preventDefault();
        const cur = parseInt(this.modal.getAttribute('data-current-index') || '0', 10);
        this.showLookPanel(cur + 1, 'next');
        return;
      }

      const closeBtn = e.target.closest('.iconic-modal__close');
      if (closeBtn) {
        this.modal.classList.remove('is-active');
        this.modal.querySelectorAll('.iconic-look-panel').forEach(p => {
          p.classList.remove('products-open');
        });
        document.body.style.overflow = '';
        return;
      }

      if (window.innerWidth < 768) {
        const imageArea = e.target.closest('.iconic-look-panel__image');
        if (imageArea) {
          const panel = imageArea.closest('.iconic-look-panel');
          if (panel) {
            panel.classList.toggle('products-open');
            if (panel.classList.contains('products-open')) {
              const productsEl = panel.querySelector('.iconic-look-panel__products');
              if (productsEl) this.modal.style.setProperty('--popup-height', productsEl.offsetHeight + 'px');
            } else {
              this.modal.style.setProperty('--popup-height', '0px');
            }
          }
          return;
        }
      }

      if (e.target === this.modal && this.modal.classList.contains('is-active')) {
        this.modal.classList.remove('is-active');
        this.modal.querySelectorAll('.iconic-look-panel').forEach(p => {
            p.classList.remove('products-open');
        });
        document.body.style.overflow = '';
      }
    }

    handleSwipeStart(e) {
      if (e.target.closest('.iconic-look-panel__products')) return;
      if (e.target.closest('button, a')) return;

      this.isSwiping = true;

      if (e.type === 'mousedown') {
        e.preventDefault();
        this.startX = e.clientX;
        this.startY = e.clientY;
      } else {
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
      }
    }

    handleSwipeEnd(e) {
      if (!this.isSwiping) return;
      this.isSwiping = false;

      let endX, endY;
      if (e.type === 'mouseup') {
        endX = e.clientX;
        endY = e.clientY;
      } else {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
      }

      const diffX = endX - this.startX;
      const diffY = endY - this.startY;

      if (Math.abs(diffX) < 50 || Math.abs(diffX) < Math.abs(diffY)) {
        return;
      }

      const cur = parseInt(this.modal.getAttribute('data-current-index') || '0', 10);

      if (diffX < 0) {
        this.showLookPanel(cur + 1, 'next');
      } else {
        this.showLookPanel(cur - 1, 'prev');
      }
    }

    handleDragStart(e) {
      const p = e.target.closest('.iconic-look-panel__products');
      if (!p) return;
      this.isDown = true;
      this.activeDragPanel = p;
      this.dragStartX = e.pageX - p.offsetLeft;
      this.scrollLeft = p.scrollLeft;
      this.activeDragPanel.style.cursor = 'grabbing';
      e.preventDefault();
    }

    handleDragMove(e) {
      if (!this.isDown || !this.activeDragPanel) return;
      e.preventDefault();
      const x = e.pageX - this.activeDragPanel.offsetLeft;
      const walk = (x - this.dragStartX) * 1.5;
      this.activeDragPanel.scrollLeft = this.scrollLeft - walk;
    }

    handleDragEnd() {
      if (!this.activeDragPanel) return;
      this.isDown = false;
      this.activeDragPanel.style.cursor = '';
      this.activeDragPanel = null;
    }

    addLooksToCart(button) {
      if (this.isAddingToCart) return;

      const panel = button.closest('.iconic-look-panel');
      if (!panel) return;

      const productCards = panel.querySelectorAll('.iconic-product-card');
      const items = [];
      productCards.forEach(card => {
        const variantId = card.getAttribute('data-variant-id');
        const available = card.getAttribute('data-available') === 'true'; // Wait, in liquid it outputs directly the boolean, but as string 'true' or 'false'
        
        if (available && variantId && variantId !== '') {
            items.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
      });

      if (!items.length) {
         return;
      }

      const groupedItems = new Map();
      items.forEach(item => {
        if (groupedItems.has(item.id)) {
            groupedItems.get(item.id).quantity += item.quantity;
        } else {
            groupedItems.set(item.id, { ...item });
        }
      });
      const finalItems = Array.from(groupedItems.values());

      this.isAddingToCart = true;

      const textSpan = button.querySelector('.iconic-add-to-cart-text');
      const spinner = button.querySelector('.iconic-spinner');
      if (textSpan) textSpan.style.display = 'none';
      if (spinner) spinner.style.display = 'block';
      button.disabled = true;

      const cartDrawer = this.findCartDrawer();
      const sectionId = this.discoverSectionId(cartDrawer);
      const sectionNames = sectionId ? [sectionId] : ['cart-drawer', 'cart-icon-bubble'];

      const formData = {
        items: finalItems,
        sections: sectionNames,
        sections_url: window.location.pathname
      };

      fetch(this.getCartUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(json => { throw new Error(json.description || json.message); });
        }
        return response.json();
      })
      .then(cart => {
        if (!cart.sections || Object.keys(cart.sections).length === 0) {
          console.warn('Sections missing from add.js response — fetching manually...');
          return fetch(`${window.location.pathname}?sections=${sectionNames.join(',')}`)
            .then(res => res.json())
            .then(sectionsData => {
              cart.sections = sectionsData;
              return cart;
            });
        }
        return cart;
      })
      .then(cart => {
        this.refreshCartDrawer(cart, cartDrawer);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'iconic-lookbook', items: finalItems, cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'iconic-lookbook', items: finalItems, cart } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: cart, cart } }));
        window.dispatchEvent(new CustomEvent('iconic-lookbook:added', { detail: { items: finalItems, cart } }));
      })
      .catch(error => {
        console.error('Lookbook – Cart Error:', error);
        alert(error.message || 'Could not add selected products to cart.');
      })
      .finally(() => {
        this.isAddingToCart = false;
        if (textSpan) textSpan.style.display = 'block';
        if (spinner) spinner.style.display = 'none';
        button.disabled = false;
      });
    }

    getCartUrl(path) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.replace(/\/?$/, '/')}${path}`;
    }

    findCartDrawer() {
      return document.querySelector('cart-drawer')
        || document.querySelector('cart-drawer-component')
        || document.querySelector('#CartDrawer')
        || document.querySelector('[data-cart-drawer]')
        || document.querySelector('.cart-drawer')
        || document.querySelector('#cart-drawer')
        || document.querySelector('#mini-cart')
        || document.querySelector('.mini-cart')
        || document.querySelector('.side-cart');
    }

    discoverSectionId(cartDrawer) {
      if (!cartDrawer) return '';
      const sectionIdEl = cartDrawer.querySelector('[data-section-id]');
      if (sectionIdEl && sectionIdEl.dataset.sectionId) return sectionIdEl.dataset.sectionId;
      if (cartDrawer.dataset && cartDrawer.dataset.sectionId) return cartDrawer.dataset.sectionId;
      const wrapper = cartDrawer.closest('.shopify-section') || cartDrawer.closest('[id^="shopify-section-"]');
      if (wrapper && wrapper.id) return wrapper.id.replace('shopify-section-', '');
      return '';
    }

    refreshCartDrawer(state, cartDrawer) {
      cartDrawer = cartDrawer || this.findCartDrawer();

      if (!cartDrawer) {
        const notification = document.querySelector('cart-notification');
        if (notification) {
          if (typeof notification.renderContents === 'function' && state && state.sections) {
            try { notification.renderContents(state); return; } catch (e) { /* fall through */ }
          }
          if (typeof notification.open === 'function') { notification.open(); return; }
        }
        window.location.href = this.getCartUrl('cart');
        return;
      }

      // Always use nuclear refresh — renderContents can conflict with the lookbook modal overlay
      this.nuclearCartRefresh(cartDrawer);
    }

    nuclearCartRefresh(cartDrawer) {
      const sectionId = this.discoverSectionId(cartDrawer) || 'cart-drawer';

      const url = `${window.location.pathname}?sections=${sectionId}`;

      fetch(url)
        .then(res => res.json())
        .then(sections => {
          const html = sections[sectionId];
          if (!html) {
            this.openCartDrawer(cartDrawer);
            return;
          }

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const replaceTargets = [
            '.cart-drawer__inner', 'cart-items-component', '.cart-drawer__content',
            '.drawer__inner', '.cart-drawer__body', '#CartDrawer-Inner', '#CartDrawer',
            '.mini-cart__content', '.side-cart__content', '.cart-drawer-items'
          ];

          let replaced = false;
          for (const selector of replaceTargets) {
            const newEl = doc.querySelector(selector);
            const curEl = cartDrawer.querySelector(selector);
            if (newEl && curEl) {
              curEl.innerHTML = newEl.innerHTML;
              replaced = true;
              break;
            }
          }

          if (!replaced) {
            const tag = cartDrawer.tagName.toLowerCase();
            const newDrawer = doc.querySelector(tag);
            if (newDrawer) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
              replaced = true;
            }
          }

          const emptyClasses = ['cart-drawer--empty', 'is-empty', 'drawer--empty', 'cart--empty'];
          emptyClasses.forEach(cls => {
            cartDrawer.classList.remove(cls);
            cartDrawer.querySelectorAll('.' + cls).forEach(el => el.classList.remove(cls));
          });
          const dialog = cartDrawer.querySelector('dialog');
          if (dialog) {
            emptyClasses.forEach(cls => dialog.classList.remove(cls));
          }

          this.openCartDrawer(cartDrawer);
          this.refreshCartBubble(doc);
        })
        .catch(err => {
          this.openCartDrawer(cartDrawer);
        });
    }

    refreshCartBubble(freshDoc) {
      const bubbleSelectors = ['#cart-icon-bubble', '.cart-count-bubble', '.cart-count', '[data-cart-count]', '.header__cart-count'];
      for (const sel of bubbleSelectors) {
        const newBubble = freshDoc.querySelector(sel);
        const curBubble = document.querySelector(sel);
        if (newBubble && curBubble) {
          curBubble.innerHTML = newBubble.innerHTML;
          break;
        }
      }
    }

    openCartDrawer(cartDrawer) {
      if (!cartDrawer) {
        const n = document.querySelector('cart-notification');
        if (n && typeof n.open === 'function') n.open();
        return;
      }

      if (typeof cartDrawer.open === 'function') {
        try { cartDrawer.open(); return; } catch (e) {}
      }

      const dialog = cartDrawer.querySelector('dialog');
      if (dialog && !dialog.open) {
        try { dialog.showModal(); } catch (e) {
          try { dialog.show(); } catch (e2) { dialog.setAttribute('open', ''); }
        }
        return;
      }

      const toggleClasses = ['active', 'is-active', 'is-open', 'drawer--active', 'cart-drawer--open'];
      toggleClasses.forEach(cls => cartDrawer.classList.add(cls));
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
    }
  }

  customElements.define('iconic-lookbook-second', IconicLookbookSecond);
})();